import ApiClient from "./apiclient";

export default class ContentService extends ApiClient {
  async query() {
    return this.GET("/contents/top");
  }

  async get(param) {
    return this.GET(`/contents/${param}`);
  }

  async getByCategory(param) {
    return this.GET(`/contents/top/bycategory/${param.id}`, {
      contentType: 'series'
    });
  }

  async getByUser(param) {
    return this.GET(`/contents/top/byuser`, { contentType: param });
  }

  async post(params) {
    return this.POST(`/contents`, params);
  }

  async delete(param) {
    return this.DELETE(`/contents/${param}`);
    // return this.DELETE(`/contents/${param}`, param);
  }

  async getContentRevisions(uuid) {
    return this.GET(`/contents/${uuid}/revision/top`);
  }

  async getSerieById(uuid) {
    return this.GET(`/series/${uuid}`);
  }

  async checkMedia(hash) {
    return this.POST(`/contents/exists/`, hash);
  }

  async getTorrentFile(uuid) {
    return this.GET(`/contents/${uuid}/torrentFile`);
  }

  async getWebLink(uuid) {
    return this.GET(`/contents/${uuid}/weblink`);
  }

  async postSubtitles(subtitle) {
    return this.POST(`/storage/subtitle/`, subtitle, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
  async postGeoblocking(geoblocking) {
    let body = {
      type: geoblocking.restriction,
      countries: geoblocking.countriesSelect
    };
    return this.POST(`/me/contents/${geoblocking.videoUuid}/geoblocking`, body);
  }
  async deleteGeoblocking(geoblocking) {
    return this.DELETE(`/me/contents/${geoblocking.videoUuid}/geoblocking`);
  }
  async getGeoblocking(geoblocking) {
    return this.GET(`/me/contents/${geoblocking.videoUuid}/geoblocking`);
  }
  async postGeoblockingSerie(geoblocking) {
    let body = {
      type: geoblocking.restriction,
      countries: geoblocking.countriesSelect
    };
    return this.POST(
      `/me/series/${geoblocking.serieUuid}/season/${
        geoblocking.seasonUuid
      }/geoblocking`,
      body
    );
  }
  async deleteGeoblockingSerie(geoblocking) {
    return this.DELETE(
      `/me/series/${geoblocking.serieUuid}/season/${
        geoblocking.seasonUuid
      }/geoblocking`
    );
  }
  async getGeoblockingSerie(geoblocking) {
    return this.GET(
      `/me/series/${geoblocking.serieUuid}/season/${
        geoblocking.seasonUuid
      }/geoblocking`
    );
  }

  async updateMetadataSerie(data) {
    return this.PATCH(`/me/series/${data.uuid}`, data.data);
  }

  async updateCoverSerie(data) {
    return this.PUT(`/series/${data.uuid}/media/cover`, data.data, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }

  async deleteEpisodes(params) {
    if (params.seasonIds) {
      return this.DELETE(`/series/${params.serieUuid}/contents`, {
        seasonIds: params.seasonIds
      });
    }
    return this.DELETE(`/series/${params.serieUuid}/contents`, {
      contentIds: params.ids
    });
  }

  async reorderEpisodes(params) {
    return this.PUT(`/series/contents/reorder`, params);
  }

  async getContentUploadUUID() {
    return this.POST(`/contents/upload`);
  }

  async uploadContentCover(contentUploadUUID, cover) {
    return this.POST(`/contents/upload/${contentUploadUUID}/media`, cover, {
      "Content-Type": "multipart/form-data",
    });
  }

  async uploadContentDetails(contentUploadUUID, details) {
    return this.POST(`/contents/upload/${contentUploadUUID}/details`, details);
  }

  async uploadContentSubtitles(contentUploadUUID, subtitle) {
    return this.POST(`/contents/upload/${contentUploadUUID}/subtitle`, subtitle, {
      "Content-Type": "multipart/form-data",
    });
  }

  async getDRMToken(contentUUID, typeDRM) {
    return this.POST(`/drm/generatetoken`, {
      "contentUUID": contentUUID,
      "type": typeDRM
    });
  }

  async getManifest(contentUUID, typeDRM) {
    return this.GET(`/contents/${contentUUID}/drm/${typeDRM}`);
  }
}
